import { all } from "redux-saga/effects";

import allTeamSagas from "./allTeams";
import crudTeamSagas from "./crudTeam";

export default function* teamsSagas() {
  yield all([allTeamSagas(), crudTeamSagas()]);
}
